module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAmCAMAAACbFsmhAAAAV1BMVEUAAABveJBwd49xeZFzepNvd5B6fZlvd5BveJBweJBweJBweJBwd49weJBxd5BzeZFzfpdvd5Bvd5BweI9weJBweZFxeJJ1epNvd5BweI9weZBwepFvd497EL0xAAAAHHRSTlMA9OtAJs0NyKuCdW+zoV0tF+TclY5RRR/Vu2Q2on2btQAAAN5JREFUOMuNlNkSgyAMRdkRcaGurfL/39mOgyzjJOW8OXOMkORKLrhZOME5pf+xoU7rL5hDnMUHGtjhPrKCUp+kFyhNPnFAEs2kDyT5DFZTqYOkd1ZIQFITnWknEDZKJwER6WoIMkgzJtl4NQQVmkAVZplQqq0qJWpOpQmGDlaPOKlX5t+aPy0FTTB90WlPZ1e8JG9Li3wStOjLzm6L2iJEcsyskaVAGM7n+ESH0gJALCBqIltlOB8qSyqSj4PCZ0qI5uFM5AmXmQD/uLZYDd1FZzsWprQSDMHXge+kmi88WTA1T7jzkwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/_icon-phone.png
// module id = HH9U
// module chunks = 0